// @flow
import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import useWindowDimensions from '../../utils/windowDemensions';
import icons from '../../utils/icons';
import styles from './styles.module.scss';

// Match the header's compact navigation breakpoint on both trainer pages.
export const TRAINER_SETTINGS_MAX_WIDTH = 1120;

type Props = { children: any, title?: string, maxWidth?: number };

const MobileSettings = ({ children, title = 'Settings', maxWidth = 766 }: Props) => {
  const { width } = useWindowDimensions();
  const [isOpen, setOpen] = useState(false);
  const [headerHost, setHeaderHost] = useState(null);
  const toggleRef = useRef(null);
  const close = () => {
    setOpen(false);
    if (toggleRef.current) toggleRef.current.focus();
  };

  useEffect(() => {
    setHeaderHost(document.getElementById('mobile-page-settings'));
    if (width > maxWidth) setOpen(false);
  }, [width, maxWidth]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') close();
    };
    const onHeaderMenu = (event) => {
      if (event.target instanceof Element && event.target.closest('[data-header-menu]')) {
        setOpen(false);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    document.addEventListener('click', onHeaderMenu);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('click', onHeaderMenu);
    };
  }, [isOpen]);

  if (width > maxWidth) return children;

  const toggle = (
    <button
      ref={toggleRef}
      type="button"
      className={styles.toggle}
      aria-label={title}
      aria-expanded={isOpen}
      aria-controls="mobile-settings-panel"
      data-game-settings
      onClick={() => setOpen(!isOpen)}
    >
      <img src={icons.settings} alt="" />
    </button>
  );

  return (
    <>
      {headerHost ? createPortal(toggle, headerHost) : toggle}
      <section
        id="mobile-settings-panel"
        className={styles.settings}
        aria-label={title}
        data-game-settings
        hidden={!isOpen}
      >
        <div className={styles.heading}>
          <span>{title}</span>
          <button type="button" onClick={close}>Done</button>
        </div>
        <div className={styles.panel}>{children}</div>
      </section>
    </>
  );
};

export default MobileSettings;
